import { render, staticRenderFns } from "./SingleBanner.vue?vue&type=template&id=99800264&scoped=true&"
import script from "./SingleBanner.vue?vue&type=script&lang=js&"
export * from "./SingleBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99800264",
  null
  
)

export default component.exports